import type { PriceDisplay } from 'src/components/price-list/types';
import { PriceDisplayEnum } from 'src/components/price-list/types';
import type { PricePrice } from 'src/types';

export function getDisplayPrice(
  price: Omit<PricePrice, '__typename'> | null | undefined,
  priceDisplay: PriceDisplay
): number | null {
  if (!price) {
    return null;
  }

  return priceDisplay === PriceDisplayEnum.PRICE_INCLUDES_SHIPPING &&
    price.inclShipping
    ? price.inclShipping || null
    : price.exclShipping || null;
}
